import { render } from "./ContactViewSettings.vue?vue&type=template&id=2b9d19eb"
import script from "./ContactViewSettings.vue?vue&type=script&lang=js"
export * from "./ContactViewSettings.vue?vue&type=script&lang=js"

import "./ContactViewSettings.vue?vue&type=style&index=0&id=2b9d19eb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__